const busList = [
  {
    id: 1,
    number: "Shimla-005",
    route: "Shimla to Mall Road",
    driver: { name: "Ramesh", phone: "98000-00001" },
    conductor: { name: "Suresh", phone: "98000-00002" },
    lastLocation: "Kufri",
    lastUpdated: "10 min ago",
  },
  {
    id: 2,
    number: "Manali-010",
    route: "Manali to Kullu",
    driver: { name: "Mahesh", phone: "98000-00003" },
    conductor: { name: "Naresh", phone: "98000-00004" },
    lastLocation: "Rangri",
    lastUpdated: "2 min ago",
  },
  // Add more mock buses if needed
];

export function getBuses(query) {
  if (!query) return [];
  return busList.filter(
    (bus) =>
      bus.number.toLowerCase().includes(query.toLowerCase()) ||
      bus.route.toLowerCase().includes(query.toLowerCase())
  );
}

export function getBusById(id) {
  return busList.find((bus) => bus.id === Number(id));
}
